import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const ICICITest = () => {
  const [testResult, setTestResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(10);
  const [orderId, setOrderId] = useState('456');

  const testEncryption = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/payment/icici/test-url`, {
        amount: parseInt(amount),
        orderId
      });
      setTestResult(response.data);
    } catch (error) {
      console.error('Test failed:', error);
      setTestResult({ error: error.message });
    } finally {
      setLoading(false);
    }
  };



  const compareValues = (our, expected) => {
    return our === expected ? '✅' : '❌';
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-2xl font-bold mb-6">ICICI EazyPay Test</h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Order ID</label>
              <input
                type="text"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Amount</label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <button
            onClick={testEncryption}
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-6 py-3 rounded-lg font-medium transition-colors mb-6"
          >
            {loading ? 'Testing...' : 'Test ICICI Encryption'}
          </button>

          {testResult && (
            <div className="space-y-6">
              {testResult.error ? (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <h3 className="text-red-800 font-semibold">Error</h3>
                  <p className="text-red-700">{testResult.error}</p>
                </div>
              ) : (
                <>
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                    <h3 className="text-green-800 font-semibold mb-2">Generated Payment URL</h3>
                    <div className="bg-white p-3 rounded border text-sm break-all">
                      <a href={testResult.paymentUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                        {testResult.paymentUrl}
                      </a>
                    </div>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <h3 className="text-blue-800 font-semibold mb-4">Encryption Comparison</h3>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b">
                            <th className="text-left py-2">Field</th>
                            <th className="text-left py-2">Our Value</th>
                            <th className="text-left py-2">Expected</th>
                            <th className="text-left py-2">Match</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-b">
                            <td className="py-2 font-medium">Mandatory Fields</td>
                            <td className="py-2 break-all">{testResult.testData.encryptedValues.mandatoryFields}</td>
                            <td className="py-2 break-all">{testResult.testData.expectedValues.mandatoryFields}</td>
                            <td className="py-2">{compareValues(testResult.testData.encryptedValues.mandatoryFields, testResult.testData.expectedValues.mandatoryFields)}</td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-2 font-medium">Return URL</td>
                            <td className="py-2 break-all">{testResult.testData.encryptedValues.returnUrl}</td>
                            <td className="py-2 break-all">{testResult.testData.expectedValues.returnUrl}</td>
                            <td className="py-2">{compareValues(testResult.testData.encryptedValues.returnUrl, testResult.testData.expectedValues.returnUrl)}</td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-2 font-medium">Order ID</td>
                            <td className="py-2 break-all">{testResult.testData.encryptedValues.orderId}</td>
                            <td className="py-2 break-all">{testResult.testData.expectedValues.orderId}</td>
                            <td className="py-2">{compareValues(testResult.testData.encryptedValues.orderId, testResult.testData.expectedValues.orderId)}</td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-2 font-medium">Sub Merchant ID</td>
                            <td className="py-2 break-all">{testResult.testData.encryptedValues.subMerchantId}</td>
                            <td className="py-2 break-all">{testResult.testData.expectedValues.subMerchantId}</td>
                            <td className="py-2">{compareValues(testResult.testData.encryptedValues.subMerchantId, testResult.testData.expectedValues.subMerchantId)}</td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-2 font-medium">Amount</td>
                            <td className="py-2 break-all">{testResult.testData.encryptedValues.amount}</td>
                            <td className="py-2 break-all">{testResult.testData.expectedValues.amount}</td>
                            <td className="py-2">{compareValues(testResult.testData.encryptedValues.amount, testResult.testData.expectedValues.amount)}</td>
                          </tr>
                          <tr>
                            <td className="py-2 font-medium">Pay Mode</td>
                            <td className="py-2 break-all">{testResult.testData.encryptedValues.paymode}</td>
                            <td className="py-2 break-all">{testResult.testData.expectedValues.paymode}</td>
                            <td className="py-2">{compareValues(testResult.testData.encryptedValues.paymode, testResult.testData.expectedValues.paymode)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                    <h3 className="text-gray-800 font-semibold mb-2">Configuration</h3>
                    <pre className="text-sm bg-white p-3 rounded border overflow-x-auto">
                      {JSON.stringify(testResult.config, null, 2)}
                    </pre>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ICICITest;